import { initializeApp } from 'firebase/app'
import { Analytics, getAnalytics, isSupported, logEvent } from 'firebase/analytics'

// Firebase web config is public by design; restrict the API key to your domains in Google Cloud.
const firebaseConfig = {
  apiKey: 'AIzaSyATT6SlvCENhZt_rloyUM7MRXYo1TnUogU',
  authDomain: 'toonswap-df1ed.firebaseapp.com',
  projectId: 'toonswap-df1ed',
  storageBucket: 'toonswap-df1ed.firebasestorage.app',
  messagingSenderId: '951629906834',
  appId: '1:951629906834:web:6414561967c735561ff74b',
  measurementId: 'G-8248XL16FE',
}

const app = initializeApp(firebaseConfig)

// Analytics can't run in some browsers (for example with storage blocked), so start it only where supported.
const analyticsPromise: Promise<Analytics | null> = isSupported()
  .then((supported) => (supported ? getAnalytics(app) : null))
  .catch(() => null)

export const logAnalyticsEvent = (name: string, params?: Record<string, string | number>) => {
  analyticsPromise.then((analytics) => {
    if (analytics) logEvent(analytics, name, params)
  })
}
